import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import "./SingleColumnFloatingPanel.scss";
import {
  BackgroundKeyToColor,
  GeneralSizeKeyToPaddingNumber,
  // GeneralHeightKeyToBarHeight,
} from "../../../utils/datasources";
import { resolveRichText } from "../../../utils/richText";
import Buttons from "../../internal/buttons/Buttons";
const SingleColumnFloatingPanel = (blok) => {
  const {
    content,
    card_background_color,
    cta_text,
    cta_link,
    cta_text_color,
    is_modal,
    card_padding_top,
    card_padding_bottom,
    modal_id,
    cta_type,
  } = blok.blok;
  const backgroundColor = BackgroundKeyToColor(card_background_color),
    cardPaddingTop = GeneralSizeKeyToPaddingNumber(card_padding_top),
    cardPaddingBottom = GeneralSizeKeyToPaddingNumber(card_padding_bottom)
  const buttonProps = {
    text: cta_text,
    url: cta_link,
    isModal: is_modal,
    textColor: cta_text_color,
    modalId: modal_id,
    component: cta_type,
  };
  return (
    <PanelWrapper blok={blok.blok}>
      <Container
        className={`single-column-floating-panel panel-radius shadow-cards card-color-handler-${card_background_color}`}
        style={{ backgroundColor: backgroundColor }}
      >
        <Row>
          <Col className="justify-content-center">
            <div className="single-column-floating-card-wrapper" style={{
                  paddingTop: cardPaddingTop,
                  paddingBottom: cardPaddingBottom,
                }}>
              <div dangerouslySetInnerHTML={resolveRichText(content)}></div>
              {cta_text ? (
                <div className="general-button-wrapper">
                  <Buttons buttonProps={buttonProps} />
                </div>
              ) : null}
            </div>
          </Col>
        </Row>
      </Container>
    </PanelWrapper>
  );
};

export default SingleColumnFloatingPanel;
